import { IconX } from '@tabler/icons-react';
import React, { useState } from 'react';
import { Modal } from 'react-bootstrap';
import InfluencerListOfAgentTable from './InfluencerListOfAgentTable';

const InfluencerListModal = ({ buttonComponent, agentData }) => {
    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    return (
        <>
            <div className='max-w-max' onClick={handleShow} >{buttonComponent}</div>

            <Modal show={show} onHide={handleClose} size='xl' >
                <Modal.Body className='rounded-xl'>
                    <div className="flex justify-between items-center">
                        <p className="text-md font-semibold mb-0">Influencer List of {agentData?.name || "Agent"}</p>
                        <IconX className='cursor-pointer' onClick={handleClose} />
                    </div>
                    <hr className='my-3' />

                    <InfluencerListOfAgentTable agentId={agentData?._id} />

                    <hr className='my-3' />
                    <div className='flex justify-end gap-3'>
                        <button className='cancel-btn' onClick={handleClose}>Close</button>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    )
}

export default InfluencerListModal